<template>
    <b-modal hide-footer id="emailModal" size="lg" title="Verifique seu E-mail" :no-close-on-backdrop="true">
        <template #modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <!-- <b-button size="sm" variant="outline-danger" @click="close()">
              Close Modal
            </b-button> -->
            <p class="h5">Verifique seu E-mail</p>
        </template>
      

        <div class="d-flex justify-content-center flex-column aling-items-center">
            <p>Identificamos que seu e-mail ainda não foi confirmado em nossa base de dados.</p>
            <p>Por favor, verifique o endereço de e-mail que você forneceu. Isto aumentará a segurança da sua conta, além de permitir que você a recupere, caso esqueça sua senha.</p>
            <p>Clique no botão abaixo para receber o link de verificação no email <b>{{ data.teacher_email }}</b> ou caso não tenha acesso ao email, clique em atualizar dados. Após concluir, recarregue a página.</p>
            <div class="mb-3 d-flex justify-content-center aling-items-center gap-3">
                <button @click="sendEmail" class="btn btn-primary align-self-center ">Enviar Link de Verificação</button>
                <a :href="data.profile_route" class="btn btn-outline-primary align-self-center">Atualizar Dados</a>
            </div>
            <p class="text-muted fs-8 font-weight-light">Se você não reconhece o e-mail informado acima, entre em contato com nossa equipe de suporte imediatamente.</p>

        </div>
    </b-modal>  
    
</template>

<script>
export default {
    props: ['data'],
    data(){
        return {
            
        }
    },
    created(){
        if(this.data && this.data.can_show){

            this.$nextTick(() => {
                    this.$bvModal.show('emailModal')
            })
            localStorage.setItem('appAlert', false);
        }
    },
    methods: {
        sendEmail(){
            axios.get(this.data.endpoint_verify_email)
            .then((result) => {
                this.$toast.success('Email de Verificação Enviado');    
            }).catch((err) => {
                this.$toas.error('Erro ao enviar email de verificação');
            });
        }
    }
}
</script>

<style>

</style>